import ListItem from "@mui/material/ListItem";
import { FormattedAmount } from "vino/core";
import {  calculateTotalAmount } from "utils";
import { useSelector } from "react-redux";

const OrderSummaryFooter = () => {
	const { subtotalPrice, totalTax, shipping, totalDiscounts } = useSelector(
		(state) => state.vino.checkout
	);
	const shippingRate = shipping.rate ? parseFloat(shipping.rate) : 0;
	const total = calculateTotalAmount(
		subtotalPrice,
		totalTax,
		totalDiscounts,
		shipping
	);

	return (
		<>
			<ListItem className="px-8">
				<div className="flex justify-between items-center w-full py-0">
					<span className="text-12 font-semibold">Subtotal</span>

					<FormattedAmount
						className="text-12 font-semibold"
						value={subtotalPrice}
					/>
				</div>
			</ListItem>

			<ListItem className="px-8">
				<div className="flex justify-between items-center w-full py-0">
					<span className="text-12 font-semibold">Tax</span>

					<FormattedAmount className="text-12 font-semibold" value={totalTax} />
				</div>
			</ListItem>

			<ListItem className="px-8">
				<div className="flex justify-between items-center w-full py-0">
					<span className="text-12 font-semibold">Shipping</span>

					<FormattedAmount
						className="text-12 font-semibold"
						value={shippingRate}
					/>
				</div>
			</ListItem>

			<ListItem className="px-8">
				<div className="flex justify-between items-center w-full py-0">
					<span className="text-12 font-semibold">Total</span>

					<FormattedAmount className="text-12 font-semibold" value={total} />
				</div>
			</ListItem>
		</>
	);
};

export default OrderSummaryFooter;
